<template>
  <div>
        <ctop />

        <div class="help_banner">
            你好！请问您需要什么帮助？
        </div>

        <search />
        <div class="c_content">
            <div class="crumbs">
                <div class="border"></div>
                <div class="now">当前位置：</div>
                <div class="one">帮助中心</div>
            </div>

        </div>

        <div class="help_list">
            <div class="content">
                <div class="title">{{info.name}}</div>
                
                <div class="l_content" v-html="info.content">
                    
                </div>
            </div>
        </div>

        <div class="mar"></div>
        <bottom />
        <right />
  </div>
</template>

<script>
import ctop from '@/components/ctop'
import cswiper from '@/components/cswiper'
import search from '@/components/search'
import bottom from '@/components/bottom'
import right from '@/components/right'
export default {
  name: 'Home',
  components: {
      cswiper,
      ctop,
      search,
      bottom,
      right
  },
  data () {
    return {
       currentPage3: 5,
       id:"",
       info:''
    }
  },
  computed: {
    
  },
  mounted() {
    this.helpinfo()
  },
  created: function () {
      this.id = this.$route.query.id
  },
  methods:{
    helpinfo(){
        this.$http.post('/api/casecontent/content',this.$qs.stringify({id:this.id})).then((res)=>{
            let callback = res.data
            if(callback.code == 200){
                this.info = callback.data
                // console.log(this.caselist)
            }else{
                
            }
        }).catch((error) => {
            console.log('获取失败')
        })
    }
  },
  
}
</script>

<style lang="scss" scoped>
$zycolor:#CF2C2E;

.c_content{
    width: 100%;
    padding:0 75px;
    box-sizing: border-box;
}
.crumbs{
    display: flex;
    border-bottom: 1px solid #eee;
    padding: 15px 0;
    align-items: center;
    .border{
        height: 20px;
        width: 5px;
        background: #CF2C2E;
        border-radius: 5px;
        margin:0 20px 0 65px;
    }
    .fu{
        margin:0 5px;
    }
}


.mar{
    width: 100%;
    height: 100px;
}
.help_banner{
    height: 600px;
    width: 100%;
    background: url('~@/assets/help.png') no-repeat;
    background-color: #F7F9FA;
    line-height: 400px;
    font-size: 32px;
}

.help_list{
    width: 100%;
    display: flex;
    justify-content: center;
    padding:20px;
    box-sizing: border-box;
    .content{
        width: 70%;
        border-bottom: 1px solid #eee;
        padding-bottom: 50px;
        .title{
            width: 100%;
            text-align: center;
            font-size: 24px;
            border-bottom:1px solid #A1A1A1;
            padding-bottom: 40px;
        }
        .l_content{
            margin-top:40px;
            /deep/ img{
                width: 100%;
            }
        }
    }    
}

.fankui{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top:40px;
    .title{
        text-align: center;
        font-size: 24px;
    }
    .content{
        width: 70%;
        .list{
            display: flex;
            align-items: center;
            margin-top:40px;
            .name{
                width: 200px;
            }
            .el-input{
                width: 600px;
            }
            textarea{
                width: 600px;
                height: 275px;
                resize:none;
                border: 1px solid #DCDFE6;
                padding:15px;
                box-sizing: border-box;
            }
        }
    }
    .fankuitijiao{
        margin-top:50px;
        background: $zycolor;
        font-size: 18px;
        padding:10px 130px;
    }
}
</style>
